import Header from "components/Headers/Header";
import ReuseableTable from "components/Tables/ReuseableTable";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Container, Spinner, Button, Card, CardHeader, CardBody, Modal, ModalBody } from "reactstrap";
import {
  deleteFanRequest,
  getFansRequests,
  updateFanRequest,
} from "store/actions/fansActions";

function FansRequestingSkype() {
  const dispatch = useDispatch();
  const { requests, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.fan
  );
  const auth = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [actionLoader, setActionLoader] = useState("");
  const [deleteLoader, setDeleteLoader] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    if (auth.uid) {
      setIsLoading(true);
      dispatch(getFansRequests(auth.uid, "", () => setIsLoading(false)));
    }
  }, [auth.uid, dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getFansRequests(auth.uid, lastDocument, () => setLoadMoreLoader(false))
    );
  };

  const markAsDone = (id) => {
    setActionLoader(id);
    dispatch(
      updateFanRequest(id, "completed", () => {
        toast.success("Fan request marked as completed.");
        dispatch(getFansRequests(auth.uid, "", () => setActionLoader("")));
      })
    );
  };

  const deleteToggle = (request) => {
    setSelectedRequest(request);
    setDeleteModal(!deleteModal);
  };

  const confirmDelete = () => {
    if (!selectedRequest) return;
    const requestId = selectedRequest.id;
    setDeleteLoader(requestId);
    dispatch(
      deleteFanRequest(requestId, () => {
        toast.success("Request deleted successfully.");
        setDeleteLoader("");
        setDeleteModal(false);
      })
    );
  };

  const columns = ["Name", "Fan Calling ID", "Type", "Created At", "Status"];
  const keyMap = {
    Name: "name",
    "Fan Calling ID": "fan_callType_value",
    Type: "fan_callType",
    "Created At": "createdAt",
    Status: "status",
  };

  const renderActions = (request) => {
    const isCompleted = request.status?.props?.children === "completed";

    return (
      <>
        <Button
          className="text-white bg-primary"
          size="sm"
          onClick={() => markAsDone(request.id)}
          disabled={isCompleted || actionLoader === request.id}
        >
          {actionLoader === request.id ? <Spinner size="sm" /> : "Mark as Done"}
        </Button>

        <Button
          size="sm"
          onClick={() => deleteToggle(request)}
          className="text-white bg-danger ml-2"
          disabled={isCompleted || deleteLoader === request.id}
        >
          {deleteLoader === request.id ? <Spinner size="sm" /> : "Delete"}
        </Button>
      </>
    );
  };
  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <h2 className="text-dark mb-4 font-weight-700" style={{ fontSize: isSmallScreen ? "18px" : "26px" }}>
          Fans Requesting WhatsApp/Zoom Call With You
        </h2>
        <Card className="shadow border-0 rounded-4 p-4">
            {isLoading ? (
              <div className="d-flex justify-content-center my-3">
                <Spinner size="md" color="primary" />
              </div>
            ) : (
              <ReuseableTable
                columns={columns}
                data={requests.map((req) => ({
                  ...req,
                  name: req?.fanData?.name,
                  fan_callType_value: req?.fan_callType_value,
                  fan_callType: req?.fan_callType,
                  createdAt: moment
                    .unix(req.created_at.seconds)
                    .format("DD MMM YYYY"),
                  status: (
                    <span
                      className={`badge ${
                        req?.status === "completed"
                          ? "badge-success"
                          : "badge-danger"
                      }`}
                    >
                      {req?.status || "N/A"}
                    </span>
                  ),
                }))}
                keyMap={keyMap}
                renderActions={renderActions}
              />
            )}

            {!isLoading && requests.length > 4 && (
              <div className="w-100 p-3 d-flex justify-content-center">
                <Button
                  color="primary"
                  onClick={loadMore}
                  disabled={!hasMoreDocument || loadMoreLoader}
                >
                  {loadMoreLoader ? <Spinner size="sm" /> : "Load More"}
                </Button>
              </div>
            )}
          </Card>
        </Container>

      <Modal isOpen={deleteModal} centered>
        <ModalBody>
          <div className="text-center">
            <p className="mt-3" style={{ fontSize: 24 }}>
              Are you sure?
            </p>
            <p style={{ fontSize: 16 }}>You want to delete this request.</p>
            <Button
              color="primary"
              onClick={() => setDeleteModal(false)}
              className="mr-2"
            >
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={confirmDelete}
              disabled={deleteLoader === selectedRequest?.id}
            >
              {deleteLoader === selectedRequest?.id ? (
                <Spinner size="sm" />
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default FansRequestingSkype;
